
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingTrackingNumbersDialog extends Serenity.EntityDialog<ShippingTrackingNumbersRow, any> {
        protected getFormKey() { return ShippingTrackingNumbersForm.formKey; }
        protected getIdProperty() { return ShippingTrackingNumbersRow.idProperty; }
        protected getLocalTextPrefix() { return ShippingTrackingNumbersRow.localTextPrefix; }
        protected getNameProperty() { return ShippingTrackingNumbersRow.nameProperty; }
        protected getService() { return ShippingTrackingNumbersService.baseUrl; }
        protected getDeletePermission() { return ShippingTrackingNumbersRow.deletePermission; }
        protected getInsertPermission() { return ShippingTrackingNumbersRow.insertPermission; }
        protected getUpdatePermission() { return ShippingTrackingNumbersRow.updatePermission; }

        protected form = new ShippingTrackingNumbersForm(this.idPrefix);

    }
}